import React from 'react';
import PropTypes from 'prop-types';
import { ListItemText } from '@material-ui/core';

function SelectionsItemText({ value }) {
    return (
        <ListItemText className={'c-sidebar__link u-ml-zero u-pl-zero'}>
            {value}
        </ListItemText>
    );
}

SelectionsItemText.propTypes = {
    value: PropTypes.string.isRequired,
};

export default SelectionsItemText;
